import Api from '@/api/Api';

export default {
  list() {
    return Api().get('/platform/accounts');
  },
};
